import React from 'react';
import ChatInterface from './ChatInterface';
import { useAgentLiveChat } from '../../contexts/AgentLiveChatContext';

/**
 * Renders the active agent↔customer chat outside any single page so it survives route changes.
 * Fixed bottom-right; only mounts when a session exists.
 */
const AgentGlobalChatDock = () => {
  const { activeChatSession, clearActiveChat } = useAgentLiveChat();

  if (!activeChatSession) {
    return null;
  }

  return (
    <div
      className="fixed bottom-4 right-4 z-[100] w-[calc(100vw-2rem)] max-w-md sm:bottom-6 sm:right-6"
      aria-live="polite"
    >
      <ChatInterface
        chatSession={activeChatSession}
        onClose={clearActiveChat}
        floating
      />
    </div>
  );
};

export default AgentGlobalChatDock;
